import { HelpCircle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿Es legal transferir mi vehículo de forma 100% digital?",
    a: "Sí. La transferencia digital se respalda en la firma electrónica avanzada (Ley 19.799), que tiene la misma validez jurídica que la firma manuscrita ante notario. Transfiérelo valida la identidad de las partes con biometría y deja trazabilidad completa de cada paso (consentimiento, IP, dispositivo y sello de tiempo).",
  },
  {
    q: "¿Cuánto demora realmente la transferencia?",
    a: "Con nuestra Transferencia Exprés dejamos tu expediente completo, validado y listo para inscripción en 72 horas, frente a los 15 a 25 días de las plataformas tradicionales. El plazo final de la inscripción definitiva depende del Registro Civil, pero llegar con la 'carpeta perfecta' evita rebotes y acelera todo el proceso.",
  },
  {
    q: "¿Necesito ir a una notaría?",
    a: "No es necesario asistir presencialmente. La firma se realiza en línea con firma electrónica avanzada. Cuando una operación requiere intervención notarial, Transfiérelo cuenta con un panel dedicado de Notaría para que el trámite siga siendo digital y trazable.",
  },
  {
    q: "¿Qué documentos necesito para transferir?",
    a: "Cédula de identidad vigente de comprador y vendedor, el padrón o certificado de inscripción del vehículo y los datos de la operación (patente, RUT y valor). Nuestro sistema revisa automáticamente la legibilidad, las vigencias y las coincidencias antes de continuar.",
  },
  {
    q: "¿Cómo se protege mi dinero durante la operación?",
    a: "Los pagos se procesan por una pasarela segura y quedan asociados a la operación con seguimiento en línea. La transferencia avanza por etapas verificadas (identidad, documentos, firma y pago), de modo que el dinero se libera solo cuando se cumplen las condiciones acordadas.",
  },
  {
    q: "¿Cómo sé que el auto no tiene problemas legales?",
    a: "Cada operación incluye el Informe Transfiérelo 360: historial de propietarios, kilometraje, revisiones técnicas, siniestros, deudas y antecedentes legales (encargo por robo, embargo o prohibición), con un semáforo de riesgo verde / amarillo / rojo. Además puedes verificar el informe públicamente mediante su código QR y sello digital.",
  },
  {
    q: "¿Cómo protegen mis datos personales?",
    a: "Cumplimos la Ley 19.628 y la nueva Ley 21.719 de protección de datos: tratamos solo la información necesaria, con tu consentimiento, y puedes ejercer tus derechos ARCO (acceso, rectificación, cancelación y oposición) directamente desde la plataforma.",
  },
  {
    q: "¿La plataforma sirve para automotoras y concesionarios?",
    a: "Sí. Las automotoras cuentan con carga masiva de operaciones, gestión de sucursales y ejecutivos, ranking y reportes. Es ideal para gestionar grandes volúmenes de transferencias sin perder trazabilidad ni control.",
  },
];

export const FaqSection = () => (
  <section id="faq" className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24" data-testid="faq-section">
    <div className="grid lg:grid-cols-3 gap-10 lg:gap-16 items-start">
      <div className="lg:sticky lg:top-28">
        <div className="inline-flex items-center gap-2 rounded-full bg-[#13315C]/[0.04] px-3 py-1.5 mb-4">
          <HelpCircle size={15} className="text-[#1F9BD7]" />
          <span className="tf-label">Preguntas frecuentes</span>
        </div>
        <h2 className="font-display font-bold text-3xl md:text-4xl text-[#13315C] leading-tight">
          Resolvemos tus dudas antes de empezar
        </h2>
        <p className="mt-4 text-slate-600 leading-relaxed">
          Todo lo que necesitas saber sobre transferir tu vehículo de forma digital, segura y en 72 horas.
        </p>
        <Link
          to="/quienes-somos"
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#13315C] hover:gap-2.5 transition-all"
          data-testid="faq-about-link"
        >
          ¿Por qué elegirnos? Conócenos <ArrowRight size={15} />
        </Link>
      </div>

      <div className="lg:col-span-2">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-slate-200">
              <AccordionTrigger
                className="text-base font-display font-semibold text-[#13315C] hover:no-underline py-5"
                data-testid={`faq-trigger-${i}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed text-[15px] pr-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
